import { useState, useEffect, useRef } from "react";

const PLACE_WORDS = new Set([
  "street", "avenue", "road", "boulevard", "lane", "drive", "way", "place",
  "city", "town", "village", "county", "state", "country", "nation",
  "park", "beach", "mountain", "lake", "river", "valley", "hill",
  "office", "hospital", "school", "university", "college", "airport",
  "hotel", "restaurant", "cafe", "bar", "gym", "store", "shop",
  "york", "london", "paris", "berlin", "tokyo", "chicago", "angeles", "francisco",
]);

const YEAR_PATTERN = /\b(19|20)\d{2}\b/;
const NUMBER_PATTERN = /\b\d+(\.\d+)?\b/;

function isTextSpecific(text: string): boolean {
  if (text.length < 15 || text.length > 200) return true;

  if (NUMBER_PATTERN.test(text)) return true;
  if (YEAR_PATTERN.test(text)) return true;

  const words = text.split(/\s+/);
  const bodyWords = words.slice(1);

  for (const word of bodyWords) {
    const clean = word.replace(/[^a-zA-Z]/g, "");
    if (clean.length >= 2 && clean[0] === clean[0].toUpperCase() && clean[0] !== clean[0].toLowerCase()) {
      return true;
    }
  }

  const lower = text.toLowerCase();
  for (const place of PLACE_WORDS) {
    if (lower.includes(place)) return true;
  }

  return false;
}

export function useVaguenessDetection(value: string, debounceMs = 1500) {
  const [isVague, setIsVague] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current);

    const len = value.trim().length;
    if (len < 15 || len > 200) {
      setIsVague(false);
      return;
    }

    timerRef.current = setTimeout(() => {
      setIsVague(!isTextSpecific(value));
    }, debounceMs);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [value, debounceMs]);

  return isVague;
}
